// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/date/any.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'play.date',
	post: false,
	require: function(config, filter) { return sorted('play.date', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('MAX(p.play_date)', sortReverse('play.date', filter), sortPriority('play.date', filter))
		query.order('MAX(p.play_id)', !!filter.sortReverse, 100)
		query.leftjoin('p')
		query.join('game', 'g')
	}
}
